export const searchConst = {
  orderId: "orderId",
  token: "t",
  status: "status",
  cryptoCurrency: "cryptoCurrency",
  network: "network",
  qrString: "qrstring",
  cryptoAmount: "cryptoAmount",
  verification: "verify",
  platform: "platform",
  partnerId: "partnerId",
};
